import styled from 'styled-components/macro';
export const LinkStyled = styled.button ``;
